// src/pages/SplashScreen.js

import React from "react";
import sininLogo from "../assets/sinin-logo.svg";

const SplashScreen = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "radial-gradient(circle at 20% 15%, rgba(37,244,223,.45), transparent 30%), linear-gradient(135deg, #071416, #05080a 62%, #10151a)",
        color: "#fff",
      }}
	  >
		  <img src={sininLogo} alt="SININ" style={{ width: 280, maxWidth: "72vw" }} />
    </div>
  );
};

export default SplashScreen;
